import { CheckCircle2, Download, MonitorDown, Share2, Smartphone } from 'lucide-react';
import { useEffect, useState } from 'react';
import Modal from './Modal.jsx';
import { useLanguage } from './LanguageProvider.jsx';
import { requestInstall, subscribeInstall } from '../lib/install.js';

export default function InstallApp(){
  const { t } = useLanguage();
  const [available,setAvailable]=useState(false);
  const [installed,setInstalled]=useState(false);
  const [helpOpen,setHelpOpen]=useState(false);
  const standalone=window.matchMedia?.('(display-mode: standalone)').matches||window.navigator.standalone===true;

  useEffect(()=>subscribeInstall(setAvailable),[]);
  // المتصفح وحده يعرف إن كان التطبيق مثبَّتاً على الجهاز — نسأله بدل التخمين
  useEffect(()=>{
    let alive=true;
    navigator.getInstalledRelatedApps?.()
      .then((apps)=>{ if(alive&&apps&&apps.length) setInstalled(true); })
      .catch(()=>{});
    return ()=>{alive=false;};
  },[]);

  if(standalone) return <span className="installed-app-label"><CheckCircle2/>{t('install.installed')}</span>;

  // مثبَّت مسبقاً: المتصفح لا يسمح بتثبيته مرتين، فالمطلوب دلالة على مكانه لا زر تثبيت
  const alreadyInstalled=installed&&!available;
  const install=async()=>{
    if(available){ const accepted=await requestInstall(); if(!accepted) setHelpOpen(true); }
    else setHelpOpen(true);
  };

  return <>
    <button className={`install-app-button ${alreadyInstalled?'install-app-button--done':''}`}
      onClick={install} aria-label={alreadyInstalled?t('install.where'):t('install.button')}>
      {alreadyInstalled?<CheckCircle2/>:<Download/>}
      <span>{alreadyInstalled?t('install.alreadyButton'):t('install.button')}</span>
    </button>

    {helpOpen?<Modal title={t('install.title')} onClose={()=>setHelpOpen(false)}>
      <div className="install-help">
        {alreadyInstalled
          ? <p className="install-done"><CheckCircle2/>{t('install.alreadyHint')}</p>
          : <p>{t('install.description')}</p>}

        <h3 className="install-help__title"><MonitorDown/>{t('install.location')}</h3>
        <article><MonitorDown/><span><strong>{t('install.windows')}</strong>
          <small>{t('install.windowsHint')}</small></span></article>

        <article><Smartphone/><span><strong>{t('install.android')}</strong>
          <small>{t('install.androidHint')}</small></span></article>

        <article><Share2/><span><strong>{t('install.ios')}</strong>
          <small>{t('install.iosHint')}</small></span></article>

        {!available&&!alreadyInstalled?<article><Download/><span><strong>{t('install.browser')}</strong>
          <small>{t('install.browserHint')}</small></span></article>:null}

        <p className="install-note">{t('install.iconHint')}</p>
      </div>
    </Modal>:null}
  </>;
}
